import { render, staticRenderFns } from "./CurrencyConverter.vue?vue&type=template&id=84654e38"
import script from "./CurrencyConverter.vue?vue&type=script&lang=js"
export * from "./CurrencyConverter.vue?vue&type=script&lang=js"
import style0 from "./CurrencyConverter.vue?vue&type=style&index=0&id=84654e38&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports